import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { Icon } from '../icon'

type GigiInfoModalProps = {
  isOpen: boolean
}

export const GigiInfoModal = (props: GigiInfoModalProps) => {
  const { classes } = useStyles()
  const { isOpen } = props
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.main
  return (
    <div
      className={classes.root}
      style={{ display: isOpen ? 'flex' : 'none' }}
    >
      <div className={classes.iconWrapper}>
        <Icon
          view="gigiInfo"
          width={16}
          style={{ alignSelf: 'flex-start' }}
        />
      </div>
      <span>{texts.gigiInfo}</span>
    </div>
  )
}
